// shortLink.js
'use strict';
import { fromJS } from 'immutable';
import {
  ADD_SHORT_LINKS,
  // -- PLOP_PREPEND_REDUCER_ACTION_TYPE --
  LOGOUT,
} from '../ActionTypes.js';

export const defaultState = fromJS({});

/**
 * Short link.
 * @module reducer/shortLink
 */
const shortLink = (state = defaultState, action) => {
  switch (action.type) {
    case ADD_SHORT_LINKS:
      return _ADD_SHORT_LINKS(action.payload)(state);
    // -- PLOP_PREPEND_REDUCER_SWITCH_CASE --
    case LOGOUT:
      return _LOGOUT(action.payload)(state);
    default:
      return state;
  }
};

/**
 *
 * @kind reducer/actionType
 * @name
 * @param {object} payload.shortLink - payload
 * @return {Immutable.Map} New state
 */
const _ADD_SHORT_LINKS =
  ({ shortLink }) =>
  state => {
    return state.mergeDeep(shortLink);
  };

// -- PLOP_PREPEND_REDUCER_ACTION_HANDLER --

/**
 * Logout
 * @kind reducer/actionType
 * @name LOGOUT
 * @return {Immutable.Map} New state
 */
const _LOGOUT = () => () => {
  return defaultState;
};

export default shortLink;
